/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { baseRequest } from './baseRequest';
const internalBaseRoute = '/api/internal/tasks';
export const completeTask = async (taskId, body) => {
  return baseRequest.post(`${internalBaseRoute}/${taskId}/complete`, body);
};
export const getRedirectTaskFetchUrl = async (taskId, allDocs) => {
  return baseRequest.get(`${internalBaseRoute}/${taskId}/redirect-url?allDocs=${String(allDocs)}`);
};
export const internalUpdateTask = async (taskId, body) => {
  return baseRequest.patch(`${internalBaseRoute}/${taskId}`, body);
};
export const getRecipients = async (taskId, envelopeId) => {
  return baseRequest.get(`${internalBaseRoute}/${taskId}/recipients/${envelopeId}`);
};
export const patchRecipients = async (taskId, envelopeId, body) => {
  return baseRequest.patch(`${internalBaseRoute}/${taskId}/recipients/${envelopeId}`, body);
};